import { Card, Form, Input, message, Modal, Select, Upload } from 'antd'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import CustomButton from '../../../components/CustomButton'
import { actionCreateCategorySEO, actionGetTextFooterById } from '../../../redux/post/actions'
import btnX from '../../assets/images/btnX.png'
import { convertToSlug } from '../../lib/common'
import { CaretDownOutlined } from '@ant-design/icons'
import EditorTiny from '../../lib/editorTiny/tinymce'
import { injectIntl } from 'react-intl'
import { useHistory, withRouter } from 'react-router-dom/cjs/react-router-dom'
import { useSubheader } from '../../../_metronic/layout'
const formRef = React.createRef()
function CreateUpdateCategorySEO(props) {
    const dispatch = useDispatch()
    const history = useHistory()
    const suhbeader = useSubheader();
    const [recordModal, setRecordModal] = useState(null)
    const { intl, onCloseModal, filterModal } = props
    suhbeader.setTitle(intl.formatMessage({ id: 'SIDEBAR.LIST_POST_CATEGORY' }));
    const [dataEditor, setDataEditor] = useState('')
    const { dataCategorySEO } = useSelector(state =>
        ({  
            dataCategorySEO: state.postReducer.dataCategorySEO,
        })
            , shallowEqual)
    const getData = (data) => {
        setDataEditor(data)
    }

    const onBack = () => {
        history.push('/category-seo')
    }

    let listCategorySEO =  dataCategorySEO?.list
    // const _url = listCategorySEO.filter(item => dataCategorySEO?.rows?.map((e) => e.url).includes(item.url))
    const asyncFunc = async () => {
        if (props.match.params.id && props.match.params.id !== '0') {
            const data = await dispatch(actionGetTextFooterById({ id: props.match.params.id }));
            if (data) {
                setRecordModal(data);
                const {
                    url,
                    title,
                    text_footer,
                    title_seo,
                    description
                } = data
                formRef.current.setFieldsValue({
                    url: url || "",
                    title: title || "",
                    title_seo: title_seo || "",
                    description: description || "",
                    text_footer: text_footer || "",
                })
            }
        }
    }

    useEffect(() => {
        asyncFunc()
            formRef.current.setFieldsValue({
                url: recordModal?.url
            })
    }, [dispatch])

    const onSubmit = async () => {
        await formRef.current.validateFields();

        const data = formRef.current.getFieldsValue()

        let dataPush = {
            id: recordModal?.id,
            text_footer: dataEditor !== "" ? dataEditor : data.text_footer,
            url: data?.url,
            title_seo: data?.title_seo || '',
            description: data?.description || '',
            title: listCategorySEO.find(item => item.url === data.url).title
        }
        let messageSuccess = "Thêm mới thành công"
        //Sửa

        if (recordModal && recordModal?.id) {
            dataPush = {
                id: recordModal.id,
                ...dataPush
            }
            messageSuccess = "Cập nhật thành công"
        }
        const res = actionCreateCategorySEO({
            dataPush,
            filterModal
        })

        await dispatch(res);
        console.log("res", res);
        if (res) {
            history.push('/category-seo')
            return message.success(messageSuccess)
        }
    }

    return (
        <>
            <Card>
                <Form ref={formRef}>
                <div className="layout-form-header row">
                    <div className='col-sm-6 mb--16'>
                        <div className="customLabel">Danh mục {' '}
                            <span className="customRequired">*</span>
                        </div>
                        <Form.Item
                            name="url"
                            rules={[{
                                validator: (_, value) => {
                                    if (!value || value.trim() === '') {
                                        return Promise.reject('Vui lòng chọn danh mục')
                                    }
                                    return Promise.resolve()
                                }
                            }]}
                        >
                            <Select className='customSelect' disabled={ recordModal?.id !== undefined } >
                                {dataCategorySEO?.list?.map((e) => {
                                        return (
                                            <Select.Option value={`${e.url}`}>{e.title}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-sm-12 mb--16">
                        <div className="customLabel">
                            Tiêu đề trang
                        </div>
                        <Form.Item
                            name="title_seo"
                        >
                            <Input
                                type="text"
                                className="customInput width100"
                                placeholder=""
                            />
                        </Form.Item>
                    </div>
                    <div className="col-sm-12 mb--16">
                        <div className="customLabel">
                            Mô tả trang
                        </div>
                        <Form.Item
                            name="description"
                        >
                            <Input.TextArea rows={4} />
                        </Form.Item>
                    </div>
                    <div className='col-sm-12 mb--16'>
                        <div className="customLabel">Nội dung SEO</div>
                            <Form.Item
                                name="text_footer"
                            >
                                <EditorTiny data={recordModal && recordModal.id ? recordModal.text_footer : ''} getData={getData} />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="ant-pro-footer-bar" >
                        <div className="ant-pro-footer-bar-left" />
                        <div className="ant-pro-footer-bar-right">
                            <button type="button" className="ant-btn mr--16" onClick={onBack} >
                                <span>Cancel</span>
                            </button>
                            <button type="button" className="ant-btn ant-btn-primary" onClick={onSubmit}>
                                <span>OK</span>
                            </button>
                        </div>
                    </div>
                </Form>
            </Card>
        </ >
    )
}
export default injectIntl(withRouter(CreateUpdateCategorySEO));